import React, { useState } from "react";
import { FaFacebookF, FaLinkedinIn } from "react-icons/fa";

import BoniAmin from "../../assets/team/Boni_amin.jpeg";
import SaroarHossinSagor from "../../assets/team/saruar_hossain.jpeg";
import Ibrahim from "../../assets/team/ibrahim.jpeg";
import MasudBillah from "../../assets/our-team/MasudBillah.jpg";
import MOHAMMADSUMON from "../../assets/team/Mohammad Sumon.jfif";

import AboutBanner from "../AboutUs/AboutBanner";
import SisterConcerms from "../AboutUs/SisterConcerms";
import Achievements from "../AboutUs/Achievements";

// মেইন ডেটা অ্যারে
export const executiveData = [
  {
    id: 1,
    name: "MD. Boni Amin Fakir",
    title: "Chairman at Iconic Unity Group",
    description:
      "Leading the strategic direction, corporate governance, and sustainable expansion of the entire organization.",
    image: BoniAmin,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 2,
    name: "MD. Masud Billah",
    title: "Vice-Chairman at Iconic Unity Group",
    description:
      "Providing executive guidance, policy development, and operational support to drive company initiatives.",
    image: MasudBillah,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 3,
    name: "Saroar Hossin Sagor",
    title: "Managing Director at Iconic Unity Group",
    description:
      "Spearheading overall business execution, technological innovation, and growth across business units.",
    image: SaroarHossinSagor,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 4,
    name: "MD. Ibrahim",
    title: "Finance Director at Iconic Unity Group",
    description:
      "Overseeing corporate finance, risk management strategies, and fiscal sustainability for long-term targets.",
    image: Ibrahim,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 5,
    name: "Mohammad Sumon",
    title: "Administration Director at Iconic Unity Group",
    description:
      "Managing organizational operations, administrative policies, and workflow efficiency across departments.",
    image: MOHAMMADSUMON,
    socials: { facebook: "#", linkedin: "#" },
  },
];

const ManagementCard = ({ member }) => {
  const [hovered, setHovered] = useState(false);

  const handleCardClick = () => {
    window.open(`/about-us/board-of-directors/details/${member.id}`, "_blank");
  };

  return (
    <div
      onClick={handleCardClick}
      style={{
        width: "100%",
        borderRadius: "12px",
        overflow: "hidden",
        background: "#fff",
        boxShadow: hovered
          ? "0 10px 30px rgba(192, 4, 212, 0.15)"
          : "0 2px 12px rgba(0,0,0,0.06)",
        transition: "box-shadow 0.3s ease, transform 0.3s ease",
        transform: hovered ? "translateY(-6px)" : "translateY(0)",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        cursor: "pointer",
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Image Area */}
      <div
        style={{
          position: "relative",
          width: "100%",
          background: "linear-gradient(135deg, #f3e8ff 0%, #fae8ff 100%)",
          height: "500px",
          overflow: "hidden",
        }}
      >
        {member?.image ? (
          <img
            src={member?.image}
            alt={member.name}
            style={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        ) : (
          <div
            style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#f1f5f9",
            }}
          >
            <svg
              viewBox="0 0 100 100"
              width="80"
              height="80"
              style={{ margin: "auto" }}
            >
              <circle cx="50" cy="35" r="20" fill="#cbd5e1" />
              <ellipse cx="50" cy="85" rx="38" ry="25" fill="#cbd5e1" />
            </svg>
          </div>
        )}

        {/* Social Icons */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(192, 4, 212, 0.55)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "14px",
            opacity: hovered ? 1 : 0,
            transition: "opacity 0.3s ease",
          }}
        >
          <a
            href={member.socials.facebook}
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              background: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#c004d4",
              fontSize: "16px",
              textDecoration: "none",
            }}
          >
            <FaFacebookF />
          </a>
          <a
            href={member.socials.linkedin}
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              background: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#c004d4",
              fontSize: "16px",
              textDecoration: "none",
            }}
          >
            <FaLinkedinIn />
          </a>
        </div>
      </div>

      {/* Text Area */}
      <div
        style={{
          padding: "20px",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <h3
          style={{
            margin: "0 0 4px",
            fontSize: "20px",
            fontWeight: "700",
            color: "#1a1a2e",
          }}
        >
          {member.name}
        </h3>
        <p
          style={{
            margin: "0 0 8px",
            fontSize: "13px",
            fontWeight: "600",
            color: "#bd06d3",
          }}
        >
          {member.title}
        </p>
        <p
          style={{
            margin: "0",
            fontSize: "13px",
            color: "#64748b",
            lineHeight: "1.5",
          }}
        >
          {member.description}
        </p>
      </div>
    </div>
  );
};

const ExecutiveCommittee = () => {
  return (
    <section
      style={{
        fontFamily: "'Segoe UI', system-ui, sans-serif",
        width: "100%",
        paddingBottom: "20px",
        background: "#f8fafc",
      }}
    >
      <AboutBanner
        text={"Our Executive Committee"}
        des={`Our Executive Committee brings together experienced leaders, strategic thinkers, and industry experts who guide the vision, governance, and sustainable growth of Iconic Unity Group.`}
      ></AboutBanner>

      <div
        style={{ maxWidth: "1440px", margin: "0 auto", padding: "20px 20px" }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "30px",
            width: "100%",
            justifyContent: "center",
            marginBottom: "40px",
          }}
        >
          {executiveData.map((member) => {
            return (
              <div
                key={member.id}
                style={{
                  width: "calc(33.333% - 20px)",
                  minWidth: "260px",
                  maxWidth: "395px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <ManagementCard member={member} />
              </div>
            );
          })}
        </div>
      </div>

      {/* Sister Concern & Achievements */}
      <Achievements></Achievements>
      <SisterConcerms></SisterConcerms>
    </section>
  );
};

export default ExecutiveCommittee;
